module.exports = __webpack_public_path__ + "img/droplets-03.8058aa03.svg";